import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWifi = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Mobile_Laptop_Wifi_",
	"data-name": "Mobile, Laptop, Wifi,",
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12347",
			"data-name": "Path 12347",
			d: "M0,0H40V40H0Z",
			transform: "translate(40 40) rotate(180)",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12348",
			"data-name": "Path 12348",
			d: "M0,0H40V40H0Z",
			transform: "translate(40 40) rotate(180)",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12349",
			"data-name": "Path 12349",
			d: "M0,0H40V40H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12350",
			"data-name": "Path 12350",
			d: "M8.25,5.125h0A3.124,3.124,0,0,0,5.125,8.25h0",
			transform: "translate(3.417 3.417)",
			fill: "none",
			stroke: "#656565",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12351",
			"data-name": "Path 12351",
			d: "M8.667,2A6.667,6.667,0,0,0,2,8.667",
			transform: "translate(1.333 1.333)",
			fill: "none",
			stroke: "#656565",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12352",
			"data-name": "Path 12352",
			d: "M5,18.333V10",
			transform: "translate(3.333 6.667)",
			fill: "none",
			stroke: "#656565",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12353",
			"data-name": "Path 12353",
			d: "M23.333,10V8.333A3.347,3.347,0,0,0,19.97,5H10",
			transform: "translate(6.667 3.333)",
			fill: "none",
			stroke: "#656565",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12354",
			"data-name": "Path 12354",
			d: "M24.083,8H17.208a3.332,3.332,0,0,0-3.333,3.333v15a3.332,3.332,0,0,0,3.333,3.333h6.875a3.332,3.332,0,0,0,3.333-3.333v-15A3.332,3.332,0,0,0,24.083,8Z",
			transform: "translate(9.25 5.333)",
			fill: "none",
			stroke: "#656565",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12355",
			"data-name": "Path 12355",
			d: "M17.06,18.75h2.917",
			transform: "translate(11.373 12.5)",
			fill: "none",
			stroke: "#656565",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12356",
			"data-name": "Path 12356",
			d: "M21.125,15H4.667A1.667,1.667,0,0,0,3,16.667v1.667a3.332,3.332,0,0,0,3.333,3.333H21.125",
			transform: "translate(2 10)",
			fill: "none",
			stroke: "#656565",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgWifi;
